import {BaseCollaboratorModal} from 'sma.applicant/components/collaborators/base_collaborator_modal';

var collaboratorRow = require('sma.applicant/tasks/partials/collaborator_row.mustache');

class CollaboratorGrid extends BaseCollaboratorModal {

	constructor(config) {
		super(
			{
				applicationId: config.applicationId,
				isOwner: config.isOwner,
				includeOwner: false,
			}
		);
	}

	buildCollaboratorRows(collaborators) {
		var renderedCollaborators = [];

		// For each collaborator, build the row and set initial values. 
		$.each(collaborators, (i, el) => {
			el['isAppOwner'] = this.isAppOwner;
			el['returnUrl'] = reverse('application-dashboard');

			var rendered = $(collaboratorRow(el));

			var dropSelect = $('.custom-select:first', rendered);

			dropSelect.find('option[value="' + el.permission + '"]').attr('selected', 'selected').end();

			renderedCollaborators.push(rendered[0].outerHTML);
 		});

		this.renderedCollaboratorGrid(renderedCollaborators);
	}

	renderedCollaboratorGrid(renderedCollaborators) {
		$(".collaborator-grid").empty();
	
		if (typeof(renderedCollaborators) == "undefined" || renderedCollaborators.length == 0) {
			//$(".collaborator-grid").append(emptyProgramList(context));
		}
		else {
			$(".collaborator-grid").append(renderedCollaborators);
		}

		this.setElement($(".collaborator-grid"));
	}

}

module.exports = {
	CollaboratorGrid: CollaboratorGrid,
}